/* eslint-disable sort-keys */
import type * as core from '../../../../../../../core'

export const query: core.mosaic.Page.Query = {
  selection: {
    '@': 'breadcrumbs',
  },
  subqueries: {
    breadcrumbs: {
      target: 'ent:!health-check:!track',
      quantity: 1,
      selection: {
        '{}': {
          title: {
            '@.': '!name',
          },
          breadcrumbs: {
            '[]': [
              {
                '{}': {
                  goto: {
                    '{}': {
                      variables: {
                        '{}': {
                          healthCheckEntityId: {
                            '@$': 'healthCheckEntityId',
                          },
                          healthCheckRecordId: {
                            '@$': 'healthCheckRecordId',
                          },
                        },
                      },
                      navigationId: 'overview',
                    },
                  },
                  name: 'Overview',
                },
              },
            ],
          },
        },
      },
    },
  },
}
